import React, { useState } from 'react'
import useMedia from 'use-media'

import { breakpoints } from 'styles/media'

import MoreButton from './display/MoreButton'

const ShowMore: React.FC<{
  style?: React.CSSProperties
}> = ({ children, style }) => {
  const [expanded, setExpanded] = useState(false)

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setExpanded(!expanded)
  }

  return (
    <div>
      {expanded && children}
      <MoreButton onClick={handleClick} style={style}>
        <span>{expanded ? '-' : '+'}&nbsp;</span>
        <span>Show {expanded ? 'Less' : 'More'}</span>
      </MoreButton>
    </div>
  )
}

type ShowMoreAtBreakpointProps = {
  breakpoint: keyof typeof breakpoints
  equality: 'less_than' | 'greater_than'
  style?: React.CSSProperties
}

export const ShowMoreAtBreakpoint: React.FC<ShowMoreAtBreakpointProps> = ({
  breakpoint,
  equality,
  children,
  style,
}) => {
  const mediaQuery = (() => {
    switch (equality) {
      case 'greater_than':
        return { minWidth: breakpoints[breakpoint] }
      case 'less_than':
        return { maxWidth: breakpoints[breakpoint] }
      default:
        return null
    }
  })()

  const shouldWrapInShowMore = mediaQuery && useMedia(mediaQuery)

  if (mediaQuery && shouldWrapInShowMore) {
    return <ShowMore style={style}>{children}</ShowMore>
  }

  return <>{children}</>
}

export default ShowMore
